/* mobile nav drawer - top offset below the navbar */

(function () {
  'use strict';

  var DRAWER = 'details.menu-drawer-container';

  function measure(details) {
    var header = details.closest('.header') || document.querySelector('.header__row');
    if (!header) return;

    var bottom = header.getBoundingClientRect().bottom;

    // an unlaid-out header measures 0; leave the last good value rather than
    // pinning the panel to the top of the screen, over the navbar
    if (!(bottom > 0)) return;

    details.style.setProperty('--yg-drawer-top', Math.floor(bottom) + 'px');
  }

  function resync() {
    var open = document.querySelectorAll(DRAWER + '[open]');
    for (var i = 0; i < open.length; i++) measure(open[i]);
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var el = event.target;
      if (!el || !el.matches || !el.matches(DRAWER)) return;
      if (el.hasAttribute('open')) measure(el);
    },
    true
  );

  window.addEventListener('resize', resync, { passive: true });
  window.addEventListener('orientationchange', resync, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', resync, { passive: true });
    window.visualViewport.addEventListener('scroll', resync, { passive: true });
  }
})();
